import axiosIns from '@axios'

export class NotesService {
  static async getSiteNotes({
    siteId,
    skip,
  }: {
    siteId: number
    skip: number
  }) {
    const { data } = await axiosIns.get(
      `/site-notes/${siteId}?skip=${skip || 0}`,
    )
    return data?.data
  }

  static async createSiteNote({
    siteId,
    content,
  }: {
    siteId: number
    content: string
  }) {
    const { data } = await axiosIns.post('/site-notes', {
      note: content,
      to_site: siteId,
    })
    return data?.data
  }

  static async deleteSiteNote({ noteId }: { noteId: number }) {
    const { data } = await axiosIns.delete(`/site-notes/${noteId}`)
    return data?.data
  }

  // account notes APIs
  static async getAccountNotes({
    userId,
    skip,
  }: {
    userId: number
    skip: number
  }) {
    const { data } = await axiosIns.get(
      `/account-notes/${userId}?skip=${skip || 0}`,
    )
    return data?.data
  }

  static async createAccountNote({
    userId,
    content,
  }: {
    userId: number
    content: string
  }) {
    const { data } = await axiosIns.post('/account-notes', {
      note: content,
      to_account: userId,
    })
    return data?.data
  }

  static async deleteAccountNote({ noteId }: { noteId: number }) {
    const { data } = await axiosIns.delete(`/account-notes/${noteId}`)
    return data?.data
  }
}
